import { PATIENT_PROGRESS, PatientView } from '../../types';

export default function mapProgressLabel(patient: PatientView): { status: string; color: string } {
  if (patient.progress === PATIENT_PROGRESS.DISCHARGED) {
    return {
      status: 'Discharged',
      color: '#F2F2F2',
    };
  }
  if (patient.progress === PATIENT_PROGRESS.ON_WAITLIST) {
    return {
      status: 'On Waitlist',
      color: '#EF5DA8',
    };
  }
  if (patient?.progress === PATIENT_PROGRESS.COURSE_ENROLLED) {
    return {
      status: 'Enrolled',
      color: '#5D5FEF',
    };
  }
  if (patient?.progress === PATIENT_PROGRESS.IN_THERAPY) {
    return {
      status: 'In Therapy',
      color: '#24CD7E',
    };
  }
  return {
    status: 'Unknown',
    color: '#F2F2F2',
  };
}
